import React, { Component } from 'react';
import styles from './GenerateReport.module.css';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  createJob,
  getExportJobs,
  fetchExportJobs,
  downloadExportJob,
} from '../../modules/jobs';
import Button from '../../components/Button';
import Divider from '../../components/Divider';
import moment from 'moment';
import { saveAs } from 'file-saver';

class GenerateReport extends Component {
  state = {
    downloading: false,
    error: null,
  };

  static contextTypes = {
    router: PropTypes.object,
  };

  async componentDidMount() {
    const { fetchExportJobs } = this.props;
    const jobs = await fetchExportJobs('export-spreadsheet');
  }

  downlowad = async type => {
    const { createJob } = this.props;
    this.setState({ downloading: true });
    const data = { type: 'export-spreadsheet' };
    const result = await createJob(data);
    this.setState({ downloading: false });
  };

  downloadExportJob = async id => {
    const { downloadExportJob } = this.props;
    const data = await downloadExportJob(id);
    if (data) {
      await saveAs(data, 'CMS-export.xlsx');
      this.setState({ error: null });
    } else {
      this.setState({ error: 'spreadsheet not ready' });
    }
  };
  viewUsage = () => {
    const { router } = this.context;
    router.history.push('/admin/usage');
  };

  renderExportHistory = () => {
    const { exportJobs } = this.props;
    return (
      <div>
        <Divider />
        {exportJobs.map(job => (
          <div className={styles.singleRowContainer}>
            <div className={styles.singleRow}>
              <div className={styles.batchHeaderTitle}>{job.owner}</div>
              <div className={styles.batchHeaderTitle}>
                {moment(job.createdAt).fromNow()}
              </div>
              <div>
                <Button
                  style={{ height: 20 }}
                  text="Download"
                  onClick={() => this.downloadExportJob(job._id)}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  render() {
    const { downloading, error } = this.state;
    return (
      <div className={styles.content}>
        <div className={styles.header}>Generate Reports</div>
        <div className={styles.title}> Download all CMS data </div>
        <div className={styles.action}>
          {downloading ? (
            <button className={styles.uploading}>
              <div style={{ margin: 'auto', height: 35 }}>
                <img className={styles.loadingIcon} src="/img/loading.svg" />
              </div>
              <span>Downloading...</span>
            </button>
          ) : (
            <button
              className={styles.upload}
              onClick={e => this.downlowad('excel')}
            >
              Download Excel file (.xlsx)
            </button>
          )}
          <button className={styles.upload} onClick={this.viewUsage}>
            Render Usage
          </button>
          <div className={styles.historySection}>Export History</div>
          <div>{this.renderExportHistory()}</div>
          <div />
          {error && <span className={styles.errorTxt}>{error}</span>}
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    exportJobs: getExportJobs(state),
  }),
  { createJob, fetchExportJobs, downloadExportJob }
)(GenerateReport);



// WEBPACK FOOTER //
// ./src/containers/GenerateReport/index.js